import AsyncStorage from '@react-native-async-storage/async-storage';

const CHAVE_CONFIGURACAO_CAMPOS_IMPORTANTES =
  'NaoPerguntarNovamenteCamposImportantes';

export const salvarNaoPerguntarNovamenteCamposImportantesAsync = async () => {
  await AsyncStorage.setItem(CHAVE_CONFIGURACAO_CAMPOS_IMPORTANTES, 'True');
};

export const excluirNaoPerguntarNovamenteCamposImportantesAsync = async () => {
  await AsyncStorage.removeItem(CHAVE_CONFIGURACAO_CAMPOS_IMPORTANTES);
};

export const getNaoPerguntarNovamenteCamposImportantesAsync =
  async (): Promise<boolean> => {
    const naoPerguntarNovamenteCamposImportantes = await AsyncStorage.getItem(
      CHAVE_CONFIGURACAO_CAMPOS_IMPORTANTES
    );

    if (!naoPerguntarNovamenteCamposImportantes) {
      return false;
    }

    return naoPerguntarNovamenteCamposImportantes === 'True';
  };
